export type LegalSection = {
  id: string
  title: string
  paragraphs?: string[]
  bullets?: string[]
}

/** Combined Terms of Service + Privacy Policy for yoga schools on BookMyYogaTTC. */
export const SCHOOL_LEGAL_SECTIONS: LegalSection[] = [
  {
    id: 'acceptance',
    title: '1. Acceptance',
    paragraphs: [
      'By registering, claiming a pre-created profile, or using BookMyYogaTTC as a yoga school, you agree to these Terms of Service and Privacy Policy. If you do not agree, you may not use the platform. These apply to school owners, administrators, staff, and anyone acting on behalf of your school.',
    ],
  },
  {
    id: 'account',
    title: '2. Account registration & claim',
    paragraphs: [
      'You must provide accurate, complete, and current information when creating or claiming your account. You are responsible for keeping login credentials secure and for all activity under your account. Notify us promptly of unauthorized access.',
    ],
  },
  {
    id: 'listing',
    title: '3. Listing & verification',
    bullets: [
      'Provide complete and truthful business and contact information',
      'Submit required documents for verification when requested',
      'Keep your profile and course listings up to date',
    ],
    paragraphs: [
      'Pre-created profiles created by our team must be claimed by the authorized owner via the claim flow before full access.',
    ],
  },
  {
    id: 'content',
    title: '4. Content standards',
    paragraphs: [
      'All content you submit—including course descriptions, images, certifications, and pricing—must be accurate and not misleading. We may remove or request correction of content that violates these standards.',
    ],
  },
  {
    id: 'payments',
    title: '5. Commission & payments',
    paragraphs: [
      'For each course you set a full course fee and a booking amount (upfront payment collected online). BookMyYogaTTC charges a 10% commission on the total course fee, deducted from the booking amount paid online. The booking amount must be more than 10% of the course fee. The remaining balance of the course fee is paid by the student directly to your school on arrival. Payouts, refunds, and related terms are described in Payment Terms in your dashboard documentation.',
    ],
  },
  {
    id: 'ip',
    title: '6. Intellectual property',
    paragraphs: [
      'You retain ownership of content you upload. By submitting content, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute it on the platform and in marketing to promote your school and our services.',
    ],
  },
  {
    id: 'acceptable-use',
    title: '7. Acceptable use',
    bullets: [
      'No fraudulent or illegal activity',
      'No circumventing commission or payment obligations',
      'No harassment, spam, or discrimination',
      'No malware or harmful content',
    ],
  },
  {
    id: 'data-collection',
    title: '8. Data we collect',
    bullets: [
      'Account data: name, email, phone, business details',
      'Course and listing data you provide',
      'Booking data shared with you to fulfill reservations',
      'Payment and commission records where required',
      'Analytics to improve the platform and your insights',
    ],
  },
  {
    id: 'data-use',
    title: '9. How we use & share data',
    paragraphs: [
      'We use your data to operate your account, verify identity, process bookings, and communicate about the platform. Students see your school profile and booking-related information necessary to complete reservations. We do not sell your personal data to third parties.',
    ],
  },
  {
    id: 'security-rights',
    title: '10. Security & your rights',
    paragraphs: [
      'We use industry-standard measures to protect data, including encryption and access controls. Depending on your location, you may request access, correction, deletion, or portability of your personal data by contacting us.',
    ],
  },
  {
    id: 'cookies',
    title: '11. Cookies',
    paragraphs: [
      'We use cookies and similar technologies for authentication, session management, and improving your experience. Limiting cookies may affect some features.',
    ],
  },
  {
    id: 'termination',
    title: '12. Termination & liability',
    paragraphs: [
      'We may suspend or terminate your account for breach of these terms or operational reasons. The platform is provided "as is"; our liability is limited to the extent permitted by law.',
    ],
  },
  {
    id: 'law-changes',
    title: '13. Governing law & changes',
    paragraphs: [
      'These terms are governed by applicable law in our operating jurisdiction. We may update this document; material changes will be communicated by email or in the dashboard. Continued use after changes constitutes acceptance.',
    ],
  },
  {
    id: 'contact',
    title: '14. Contact',
    paragraphs: ['Questions: info@bookmyyogattc.com'],
  },
]
